















































































import { Component, Vue } from 'vue-property-decorator';
import commonServices from '@/services/common-services';
interface Configuration {
  MainAddress?: string;
}
@Component
export default class AppFooter extends Vue {
  private configuration: Configuration = {};
  private async created() {
    const result = await commonServices.configuration();
    if (
      result &&
      result.status === 200 &&
      result.data.message === 'Success'
    ) {
      this.configuration = result.data.data;
    }
  }
}
